var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 14.25C7.32477 14.2503 7.15494 14.1893 7.02001 14.0775C6.86663 13.9503 6.77015 13.7674 6.75186 13.569C6.73357 13.3706 6.79497 13.1731 6.92251 13.02L10.2825 9L7.04251 4.9725C6.91668 4.81755 6.85781 4.61884 6.87892 4.42036C6.90004 4.22188 6.9994 4.04 7.15501 3.915C7.31189 3.77697 7.51923 3.71064 7.72709 3.732C7.93495 3.75335 8.12448 3.86045 8.25001 4.0275L11.8725 8.5275C12.1 8.80425 12.1 9.20325 11.8725 9.48L8.12251 13.98C7.96991 14.1641 7.73869 14.2644 7.50001 14.25Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowicon);
export default __webpack_public_path__ + "static/media/arrowicon.6b9df98fef90cdb0d3ed285bf6b2ff8e.svg";
export { ForwardRef as ReactComponent };